import { useContext } from 'react';

import { AuthUserContext } from 'components/authorization';

export function useAuthUserContext() {
  const context = useContext(AuthUserContext);
  if (!context) {
    throw new Error(
      'useAuthUserContext must be used within an AuthUserProvider',
    );
  }
  return context;
}
